import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

/**
 * The entity icon for an offer — a document with lines of text.
 *
 * Filled rather than stroked, and `fill` is left to inherit `currentColor`, so
 * the colour is the caller's decision (the design's own value is gray500) and
 * the same icon can sit on a dark or a light surface without a second copy.
 *
 * Paired with `OpeningIcon`; the two are only meaningful together, as the pair
 * that distinguishes what a rule gates. Keep them visually consistent.
 *
 * `fillRule="evenodd"` is load-bearing, not decoration: the UPPER line of text
 * is a subpath wound the same way as the page it sits on, so under the default
 * `nonzero` rule it fills solid instead of punching through and the icon renders
 * as a page with one bar instead of two. The lower line is wound the other way
 * and would survive either rule — it is the upper one that needs this. Measured
 * both ways; the design's own markup omits the rule and loses the line, which is
 * invisible at its 13px but not at ours.
 */
export const OfferIcon: FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM8 16a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m1-5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
      fillRule="evenodd"
    />
  </SvgIcon>
);
